import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const GUEST_ACCESSIBLE_ROUTES = [
  "/NewsFeed",
  "/Blogs",
  "/Companies",
  "/People",
  "/SearchJob",
  "/SearchJob/Recommendations",
  "/User/",
  "/Company/",
  "/Post/",
  "/JobDetail/",
  "/SignUp",
  "/SignIn",
];

const AUTH_RESTRICTED_ROUTES = ["/SignUp", "/SignIn", "/signIn"];

const pathStartsWith = (path, prefix) =>
  typeof path === "string" &&
  typeof prefix === "string" &&
  path.toLowerCase().startsWith(prefix.toLowerCase());

const PrivateRoute = ({ element: Component, isProtected, redirectTo }) => {
  const location = useLocation();
  const currentPath =
    location?.pathname ||
    (typeof window !== "undefined" ? window.location.pathname : "") ||
    "";

  let token = localStorage.getItem("token");
  let guestMode = localStorage.getItem("guestMode");

  if (!token && !guestMode) {
    localStorage.setItem("guestMode", "true");
    guestMode = "true";
  }

  guestMode = guestMode === "true";

  const isGuestAccessible = GUEST_ACCESSIBLE_ROUTES.some((route) =>
    pathStartsWith(currentPath, route)
  );

  if (token && AUTH_RESTRICTED_ROUTES.some((route) => pathStartsWith(currentPath, route))) {
    return <Navigate to="/NewsFeed" replace />;
  }

  if (guestMode && isGuestAccessible) {
    return Component ? <Component /> : <Navigate to="/NewsFeed" replace />;
  }

  if (isProtected && !token) {
    return <Navigate to={redirectTo || "/SignIn"} replace />;
  }

  return Component ? <Component /> : <Navigate to="/NewsFeed" replace />;
};

export default PrivateRoute;
